import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/data/hooks";
import { selectIsSavingInFlight } from "@/features/authority";
import { snapshotQueueFlush } from "@/stores/listeners/snapshot-queue-listener";

/**
 * Create a callback which retries saving the snapshots if the saving is not
 * already in progress.
 *
 * @returns A tuple with the callback and a boolean indicating if the save is in
 * progress
 */
export function useRetrySaveCallback(): [() => void, boolean] {
  const dispatch = useAppDispatch();
  const saveLoading = useAppSelector(selectIsSavingInFlight);
  const onSave = useCallback(() => {
    if (!saveLoading) {
      dispatch(snapshotQueueFlush());
    }
  }, [dispatch, saveLoading]);
  return [onSave, saveLoading];
}
